export default __webpack_public_path__ + "static/media/anna-headshot.7db272f9.jpeg";